export type ChatResponseType = 'status' | 'answer' | 'error' | 'visualization';

export abstract class ChatResponseBase<TType extends ChatResponseType = ChatResponseType> {
  abstract type: TType;
}

export class ChatStatusResponse extends ChatResponseBase<'status'> {
  override type: 'status' = 'status';
  data: string = '';
}

export class ChatAnswerResponse extends ChatResponseBase<'answer'> {
  override type: 'answer' = 'answer';
  data: string = '';
}

export class ChatErrorResponse extends ChatResponseBase<'error'> {
  override type: 'error' = 'error';
  data: string = '';
}

export class ChatVisualizationResponse extends ChatResponseBase<'visualization'> {
  override type: 'visualization' = 'visualization';
  data: ChatVisualizationData = new ChatVisualizationData();
}

export class ChatVisualizationData {
  chartable: boolean = false;
  decision: string = '';
  visualizations: ChatVisualization[] = [];
  table: ChatVisualizationTable = new ChatVisualizationTable();
}

export class ChatVisualization {
  id: string = '';
  title: string = '';
  chart_type: ChatChartType = 'none';
  dataset: ChatVisualizationDataset = new ChatVisualizationDataset();
  options: ChatVisualizationOptions = new ChatVisualizationOptions();
}

export type ChatChartType =
  | 'none'
  | 'line'
  | 'line_multi'
  | 'bar'
  | 'bar_horizontal'
  | 'bar_stacked'
  | 'pie'
  | 'gauge'
  | 'pareto'
  | 'map_points'
  | 'map_connections'
  | 'map_heatmap';

export class ChatVisualizationDataset {
  x: string = '';
  y: string[] = [];
  series: string | null = null;
  lat: string | null = null;
  lon: string | null = null;
  from_lat: string | null = null;
  from_lon: string | null = null;
  to_lat: string | null = null;
  to_lon: string | null = null;
  label: string | null = null;
  from_label: string | null = null;
  to_label: string | null = null;
  value: string | null = null;
}

export class ChatVisualizationOptions {
  x_axis_label: string = '';
  y_axis_label: string = '';
  value_format: string = '';
  gauge: ChatVisualizationGauge | null = null;
}

export class ChatVisualizationGauge {
  min: number = 0;
  max: number = 0;
  thresholds: any[][] = [];
}

export class ChatVisualizationTable {
  columns: string[] = [];
  rows: any[][] = [];
}

export type ChatResponse =
  | ChatStatusResponse
  | ChatAnswerResponse
  | ChatErrorResponse
  | ChatVisualizationResponse;
